var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaundry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5102_18327",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5102_18327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75811 15.1026L2.41211 9.31056L10.2891 4.78223H11.5658C11.93 5.87467 12.4399 6.79523 13.0954 7.54389C13.751 8.29256 14.7198 8.66689 16.0018 8.66689C17.2838 8.66689 18.2526 8.29256 18.9081 7.54389C19.5637 6.79523 20.0736 5.87467 20.4378 4.78223H21.7144L29.5581 9.34389L26.2454 15.1026L23.3351 13.5052V21.3926L21.8378 22.7002C21.7796 22.7447 21.7034 22.7938 21.6094 22.8476C21.5154 22.9016 21.424 22.9464 21.3351 22.9822V10.1002L25.5018 12.4002L26.8351 10.0669L21.7351 7.10023C21.2018 8.18912 20.4206 9.05578 19.3914 9.70023C18.3623 10.3447 17.2324 10.6669 16.0018 10.6669C14.7711 10.6669 13.6412 10.3447 12.6121 9.70023C11.583 9.05578 10.8018 8.18912 10.2684 7.10023L5.13511 10.0669L6.50178 12.4002L10.6684 10.1002V17.7566C10.3216 17.7926 9.98144 17.8413 9.64811 17.9029C9.31478 17.9644 8.98822 18.0584 8.66844 18.1849V13.5052L5.75811 15.1026ZM6.24011 25.0386L4.94278 23.5182L7.58644 21.2696C8.072 20.8507 8.62544 20.531 9.24678 20.3106C9.86811 20.0899 10.5087 19.9796 11.1684 19.9796C11.8282 19.9796 12.4632 20.0899 13.0734 20.3106C13.6837 20.531 14.2316 20.8507 14.7171 21.2696L18.5838 24.5696C18.8847 24.826 19.2377 25.0196 19.6428 25.1502C20.0479 25.2809 20.4564 25.3462 20.8684 25.3462C21.294 25.3462 21.7004 25.2843 22.0878 25.1606C22.4749 25.0366 22.8189 24.8396 23.1198 24.5696L25.7634 22.2876L27.0608 23.8412L24.4171 26.0899C23.9316 26.5088 23.3837 26.8229 22.7734 27.0322C22.1632 27.2416 21.5282 27.3462 20.8684 27.3462C20.2087 27.3462 19.5681 27.2416 18.9468 27.0322C18.3254 26.8229 17.772 26.5088 17.2864 26.0899L13.4198 22.7899C13.1189 22.5334 12.7749 22.3399 12.3878 22.2092C12.0004 22.0783 11.594 22.0129 11.1684 22.0129C10.7564 22.0129 10.3479 22.0783 9.94278 22.2092C9.53767 22.3399 9.18466 22.5334 8.88378 22.7899L6.24011 25.0386Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundry);
export default __webpack_public_path__ + "static/media/laundry.d5763846522cf226396bff1db6b855a1.svg";
export { ForwardRef as ReactComponent };